import { render, staticRenderFns } from "./DiagramMCA.vue?vue&type=template&id=48568f4e&scoped=true"
import script from "./DiagramMCA.vue?vue&type=script&lang=ts"
export * from "./DiagramMCA.vue?vue&type=script&lang=ts"
import style0 from "./DiagramMCA.vue?vue&type=style&index=0&id=48568f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48568f4e",
  null
  
)

export default component.exports